import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ModalContainer from './ModalContainer';

const useStyles = makeStyles({
    closeButton: {
        color: 'var(--Z4)',
    },
    modalContainer: {
        background: ({ dataUri }) => dataUri,
        '@media (max-width: 767px)': {
            top: '200px',
        },
    },
    checkMark: {
        fontSize: '90px',
        '@media (max-width: 767px)': {
            fontSize: '70px',
        },
        color: 'var(--B1)',
        marginBottom: '48px',
    },
    blurb: {
        color: 'var(--Z3)',
        marginBottom: '40px',
        padding: '0px 20px 0px 20px',
        fontSize: '21px',
        '@media (max-width: 767px)': {
            fontSize: '16px',
        },
    },
    backdrop: {
        zIndex: '1',
        position: 'absolute',
        paddingTop: '100px',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.4)',
    },
});

const Confetti = () => <svg
    width="660"
    height="372"
    viewBox="0 0 660 372"
    fill="none"
    style={{ backgroundColor: '#ffffff' }}
    xmlns="http://www.w3.org/2000/svg"
>
    <g opacity="0.5">
        <path
            opacity="0.679913"
            d="M629.368 131.637C629.807 128.843 632.943 127.439 634.402 129.384L640.906 138.061C642.097 139.649 641.235 142.396 639.269 143.276L630.808 147.063C628.842 147.943 627.053 146.383 627.411 144.101L629.368 131.637Z"
            fill="#479FF5"
        />
        <rect
            opacity="0.89"
            width="10.5242"
            height="9.58175"
            rx="3"
            transform="matrix(0.466571 -0.884484 0.673509 0.739179 513.913 161.364)"
            fill="#479FF5"
        />
        <path
            opacity="0.552735"
            d="M505.485 19.0225C504.259 17.3474 504.633 15.0905 506.252 14.3959L514.678 10.7809C516.792 9.87399 519.311 12.2011 518.9 14.6812L516.858 27.0146C516.447 29.4947 513.471 29.928 511.869 27.7409L505.485 19.0225Z"
            fill="#479FF5"
        />
        <rect
            opacity="0.082503"
            width="11.5436"
            height="8.32551"
            rx="3"
            transform="matrix(-0.157173 0.987571 -0.949312 -0.314337 362.375 45.3244)"
            fill="#479FF5"
        />
        <rect
            opacity="0.364004"
            width="8.44427"
            height="11.457"
            rx="3"
            transform="matrix(-0.922049 0.387074 -0.197787 -0.980245 104.911 65.0624)"
            fill="#479FF5"
        />
        <rect
            opacity="0.0886049"
            width="17.9284"
            height="7.99975"
            rx="3.99987"
            transform="matrix(0.979518 0.201356 -0.0983252 0.995154 348.97 134.511)"
            fill="#479FF5"
        />
        <rect
            opacity="0.475123"
            width="17.7416"
            height="8.04077"
            rx="4.02039"
            transform="matrix(-0.999675 -0.0254857 0.0122526 -0.999925 625.919 56.2899)"
            fill="#479FF5"
        />
        <path
            opacity="0.611746"
            d="M464.789 123.732C462.985 124.158 461.625 121.761 462.271 119.295L465.511 106.928C466.193 104.327 468.57 103.609 469.73 105.653L475.535 115.884C476.694 117.928 475.736 121.147 473.834 121.596L464.789 123.732Z"
            fill="#479FF5"
        />
        <path
            opacity="0.138549"
            d="M646.476 21.8931C647.793 19.7198 651.166 20.6789 651.812 23.4105L654.644 35.3806C655.16 37.5598 653.47 39.3115 651.416 38.7272L642.812 36.2805C640.758 35.6962 639.655 33.1503 640.706 31.4165L646.476 21.8931Z"
            fill="#479FF5"
        />
        <path
            opacity="0.740617"
            d="M302.554 235.896C302.922 233.09 305.965 231.556 307.465 233.42L314.205 241.79C315.442 243.327 314.668 246.135 312.738 247.109L304.342 251.342C302.412 252.315 300.594 250.814 300.898 248.5L302.554 235.896Z"
            fill="#479FF5"
        />
        <rect
            opacity="0.490418"
            width="8.38659"
            height="11.4993"
            rx="3"
            transform="matrix(-0.935244 -0.354003 0.178992 -0.98385 537.733 261.712)"
            fill="#479FF5"
        />
        <path
            opacity="0.803906"
            d="M8.47534 214.593C8.11383 211.928 9.96706 209.598 11.748 210.479L20.4264 214.772C22.1453 215.623 22.5101 218.849 21.0894 220.635L14.1726 229.329C12.7518 231.115 10.5859 230.153 10.237 227.58L8.47534 214.593Z"
            fill="#479FF5"
        />
        <path
            opacity="0.5"
            d="M625.396 233.506C623.762 235.044 621.115 233.11 621.009 230.299L620.516 217.306C620.424 214.88 622.353 213.584 624.126 214.879L632.173 220.761C633.946 222.057 634.362 225.067 632.951 226.394L625.396 233.506Z"
            fill="#479FF5"
        />
        <rect
            opacity="0.18569"
            width="11.2001"
            height="8.78217"
            rx="3"
            transform="matrix(0.289618 0.957142 -0.846266 0.532761 635.549 261.712)"
            fill="#479FF5"
        />
        <rect
            opacity="0.280573"
            width="18.3867"
            height="7.89633"
            rx="3.94816"
            transform="matrix(-0.930947 0.365154 -0.185263 -0.982689 131.773 259.519)"
            fill="#479FF5"
        />
        <rect
            opacity="0.365154"
            width="11.3696"
            height="8.56152"
            rx="3"
            transform="matrix(-0.232375 -0.972626 0.895473 -0.445116 463.738 192.994)"
            fill="#479FF5"
        />
        <rect
            opacity="0.914854"
            width="25.5291"
            height="5.60087"
            rx="2.80044"
            transform="matrix(0.0648326 0.997896 -0.991177 0.132542 8.5918 0)"
            fill="#479FF5"
        />
        <rect
            opacity="0.633573"
            width="17.7753"
            height="8.03341"
            rx="4.01671"
            transform="matrix(-0.99602 0.0891301 -0.0429712 -0.999076 61.8317 89.1868)"
            fill="#479FF5"
        />
        <rect
            opacity="0.453155"
            width="9.56605"
            height="10.5384"
            rx="3"
            transform="matrix(-0.676865 0.736108 -0.463243 -0.886231 83.6249 233.932)"
            fill="#479FF5"
        />
        <rect
            opacity="0.178977"
            width="23.4497"
            height="6.43657"
            rx="3.21829"
            transform="matrix(0.419917 0.907562 -0.720436 0.693522 172.9 135.973)"
            fill="#479FF5"
        />
        <rect
            opacity="0.475123"
            width="14.7952"
            height="7.20222"
            rx="3.60111"
            transform="matrix(-0.999625 -0.0273741 0.0114068 -0.999935 436.061 42.8754)"
            fill="#6DAD53"
        />
        <path
            opacity="0.611746"
            d="M302.126 103.176C300.415 103.61 299.138 101.193 299.751 98.68L302.101 89.0463C302.753 86.3707 305.031 85.6034 306.132 87.6881L310.342 95.658C311.443 97.7428 310.507 101.05 308.685 101.512L302.126 103.176Z"
            fill="#6DAD53"
        />
        <path
            opacity="0.5"
            d="M436.23 201C434.662 202.585 432.029 200.518 431.927 197.621L431.575 187.634C431.489 185.195 433.329 183.957 435.042 185.301L440.8 189.822C442.513 191.167 442.957 194.198 441.636 195.533L436.23 201Z"
            fill="#6DAD53"
        />
        <rect
            opacity="0.280573"
            width="15.4888"
            height="7.05671"
            rx="3.52836"
            transform="matrix(-0.921546 0.38827 -0.17287 -0.984945 23.9987 224.912)"
            fill="#6DAD53"
        />
        <rect
            opacity="0.365154"
            width="10.1473"
            height="7.2473"
            rx="3"
            transform="matrix(-0.217116 -0.976146 0.882133 -0.471 300.82 165.324)"
            fill="#6DAD53"
        />
        <rect
            opacity="0.178977"
            width="20.7561"
            height="5.56236"
            rx="2.78118"
            transform="matrix(0.395606 0.91842 -0.695182 0.718834 58.2947 114.249)"
            fill="#6DAD53"
        />
        <rect
            opacity="0.475123"
            width="14.7952"
            height="7.20222"
            rx="3.60111"
            transform="matrix(-0.999625 -0.0273741 0.0114068 -0.999935 593.407 183.95)"
            fill="#6DAD53"
        />
        <path
            opacity="0.611746"
            d="M459.471 244.25C457.76 244.684 456.483 242.267 457.096 239.754L459.446 230.121C460.099 227.445 462.376 226.678 463.478 228.763L467.687 236.732C468.789 238.817 467.853 242.125 466.031 242.587L459.471 244.25Z"
            fill="#6DAD53"
        />
        <path
            opacity="0.5"
            d="M593.576 342.074C592.008 343.66 589.375 341.592 589.272 338.696L588.92 328.708C588.834 326.269 590.675 325.031 592.387 326.376L598.146 330.897C599.858 332.241 600.302 335.273 598.982 336.608L593.576 342.074Z"
            fill="#6DAD53"
        />
        <rect
            opacity="0.280573"
            width="15.4888"
            height="7.05671"
            rx="3.52836"
            transform="matrix(-0.921546 0.38827 -0.17287 -0.984945 181.344 365.986)"
            fill="#6DAD53"
        />
        <rect
            opacity="0.365154"
            width="10.1473"
            height="7.2473"
            rx="3"
            transform="matrix(-0.217116 -0.976146 0.882133 -0.471 458.166 306.399)"
            fill="#6DAD53"
        />
        <rect
            opacity="0.178977"
            width="20.7561"
            height="5.56236"
            rx="2.78118"
            transform="matrix(0.395606 0.91842 -0.695182 0.718834 215.64 255.324)"
            fill="#6DAD53"
        />
        <path
            opacity="0.367331"
            d="M140.843 38.4822C139.605 40.7591 136.147 40.0482 135.399 37.3629L132.143 25.673C131.551 23.5481 133.185 21.6936 135.271 22.1226L143.918 23.9004C146.004 24.3293 147.214 26.7685 146.234 28.5702L140.843 38.4822Z"
            fill="#479FF5"
        />
        <rect
            opacity="0.55591"
            width="25.277"
            height="5.7127"
            rx="2.85635"
            transform="matrix(-0.150975 -0.988538 0.953044 -0.302832 265.066 125.739)"
            fill="#479FF5"
        />
        <rect
            opacity="0.155839"
            width="17.7454"
            height="8.03995"
            rx="4.01998"
            transform="matrix(-0.999267 0.0382831 -0.0184109 -0.999831 71.9681 49.7106)"
            fill="#479FF5"
        />
        <rect
            opacity="0.0665484"
            width="25.277"
            height="5.7127"
            rx="2.85635"
            transform="matrix(-0.150975 -0.988538 0.953044 -0.302832 49.1613 183.491)"
            fill="#479FF5"
        />
        <rect
            opacity="0.5"
            width="25.5177"
            height="5.60599"
            rx="2.80299"
            transform="matrix(0.0706173 -0.997504 0.989326 0.145718 113.527 217.118)"
            fill="#479FF5"
        />
    </g>
</svg>;

const svgString = encodeURIComponent(renderToStaticMarkup(<Confetti />));
const dataUri = `url("data:image/svg+xml,${svgString}")`;

const SuccessModal = ({
    onClose, blurbText, heading, open,
}) => {
    const {
        modalContainer, closeButton, checkMark, blurb,
    } = useStyles({ dataUri });
    if (!open) return null;
    return (
        <ModalContainer onClickAway={onClose} className={modalContainer}>
            <div className="width100 displayflex justifyflexend">
                <IconButton aria-label="close" className={closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </div>
            <h2 className="head-m text-align-center mb40">{heading}</h2>
            <div />
            <CheckCircleIcon classes={{ root: checkMark }} />
            <div className={`${blurb} text-align-center`}>
                   <span
                       dangerouslySetInnerHTML={{
                           __html: blurbText,
                       }}
                   />
            </div>
        </ModalContainer>
    );
};

export default SuccessModal;
